module.exports = __webpack_public_path__ + "img/image 3.5c2a2996.png";